import { throwIfNotOk } from './responseError';

export const getRequest = (url: string, init?: RequestInit) => throwIfNotOk(fetch(url, init));
